import UserProvider from 'components/user/UserProvider';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppBar from '../AppBar';
import AppContent from '../AppContent';
import Footer from '../Footer';
import SnackbarProvider from '../SnackbarProvider';
import styles from './App.module.css';

const App: React.FC = () => {
  return (
    <UserProvider>
      <SnackbarProvider>
        <Router>
          <AppBar />
          <main className={styles.main}>
            <AppContent />
          </main>
          <footer className={styles.footer}>
            <Footer />
          </footer>
        </Router>
      </SnackbarProvider>
    </UserProvider>
  );
};

export default App;
